import React, {useEffect, useState} from 'react';
import {Menu, X, Phone, MessageCircle, ShoppingCart} from 'lucide-react';
import Link from 'next/link';
import {Badge} from "@/components/ui/badge";
import {useSelector} from "react-redux";
import {RootState} from "@/redux/store";
import Image from "next/image";

export interface NavbarMobileProps {
    isScrolled: boolean;
}
const NavbarMobile = ( {isScrolled}: NavbarMobileProps ) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const vehiclesInCart = useSelector((state: RootState) => state.cart.vehicles);
    const [isOpen, setIsOpen] = useState(false);

    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        // Indica che il componente è stato montato sul client
        setIsClient(true);
    }, []);


    return (
        <div className={`fixed top-0 left-0 w-full z-40 lg:hidden`}>
            <div
                className={`flex justify-between items-center p-4  ${menuOpen ? 'bg-white' : isScrolled ? 'backdrop-blur-md bg-white/30' : 'bg-transparent'}`}>

                <Link
                    href="/"
                    hrefLang="it"
                    title="Gruppo Piccirillo - Auto di Lusso Nuove e Usate in Italia"
                    className="flex items-center"
                >
                    <Image
                        src="/logo-vettoriale.svg"
                        alt="Gruppo Piccirillo logo"
                        width={48} // Specifica la larghezza
                        height={48} // Specifica l'altezza
                        priority={true} // Precarica l'immagine perché è un elemento critico nella UI
                        className="h-12 w-auto" // Tailwind per aggiustare ulteriormente lo stile
                    />
                </Link>

                <div className="flex gap-x-4 items-center">


                <Link href='/carrello' hrefLang={'it'} className="relative" aria-label="Vai al carrello">
                    <ShoppingCart className="hover:text-primary cursor-pointer" />
                    {isClient && vehiclesInCart && vehiclesInCart.length > 0 && (
                        <Badge className="absolute -top-2 -right-2 !px-2 text-white border-0">
                            {vehiclesInCart.length}
                        </Badge>
                    )}
                </Link>
                <button title="bugermenu" onClick={() => setMenuOpen(!menuOpen)}
                        className={`menu__button cursor-pointer rounded-full p-2 ${menuOpen ? 'bg-primary text-white' : 'bg-white'}`}>
                    {menuOpen ? <X size={24}/> : <Menu size={24}/>} {/* Replace MenuIcon with your menu icon */}
                </button>
                </div>

            </div>

            {menuOpen && (
                <div className="w-full p-4 z-[999999] h-screen bg-white shadow-md">
                    {/* Menu Links */}
                    <div className="flex flex-col  items-start px-6 font-normal gap-y-4 text-3xl">
                        <Link hrefLang="it" title="Parco Veicoli - Catalogo dei Veicoli Acquistabili"
                              onClick={() => setMenuOpen(false)} href={'/parco-veicoli'}>Acquista</Link>
                        <Link hrefLang="it" title="Vendi la tua auto" onClick={() => setMenuOpen(false)}
                              href={'/vendi-la-tua-auto/permuta'}>Vendi</Link>
                        <Link hrefLang="it" title="Rent to Buy - Catalogo dei Veicoli Noleggiabili" onClick={() => setMenuOpen(false)} href={'/rent-to-buy'}>Rent To Buy</Link>
                        <Link hrefLang="it" title="Offerte last minure" onClick={() => setMenuOpen(false)} href={'/offerta-last-minute'}>Offerte last minute</Link>
                        {/* Sezione Diventa Partner migliorata */}
                        <div className="w-full">
                            <button
                                className="w-full flex items-center justify-between font-normal text-3xl transition"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <span>Diventa Partner</span>
                                <svg
                                    className={`w-5 h-5 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>

                            <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-60' : 'max-h-0'}`}>
                                <div className="pl-2 pr-4 py-3 flex flex-col gap-y-2 ">
                                    <Link
                                        href="/diventa-partner-commercianti"
                                        className="block py-1 hover:text-primary transition"
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        Commercianti
                                    </Link>
                                    <Link
                                        href="/diventa-partner"
                                        className="block py-1 hover:text-primary transition"
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        Noleggiatori
                                    </Link>
                                    <Link
                                        href="/concessionari"
                                        className="block py-1 hover:text-primary transition"
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        Concessionari
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <Link hrefLang="it" title="F.A.Q." onClick={() => setMenuOpen(false)} href={'/faq'}>F.A.Q.</Link>
                        <Link hrefLang="it"  title="Convenzioni" onClick={() => setMenuOpen(false)} href={'/convenzioni'}
                              className="bg-gradient rounded-lg px-4 py-1 text-white transition duration-300">Convenzioni
                        </Link>
                    </div>

                    {/* Action Buttons */}
                   <div className="flex flex-col justify-center gap-y-2 items-center py-8">
                        <Link hrefLang="it" href="tel:+393925419636" title="Chiamaci"
                            className="bg-primary w-full text-white rounded-full px-6 py-2 flex justify-center items-center">
                            <Phone size={18} className="mr-2"/>
                            <span className="text-center">Chiamaci</span>
                        </Link>
                        <button
                            className="bg-primary w-full text-white rounded-full px-6 py-2 flex justify-center items-center">
                            <MessageCircle size={18} className="mr-2"/>
                            <span className="text-center">Scrivici</span>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NavbarMobile;
